<template>
  <div class="CommonInfo">
    <ld-header transparent />

    <van-tabs
      v-model="active"
      line-width="20px"
      line-height="2px"
      swipeable
      sticky
    >
      <van-tab
        name="1"
        title="常用旅客"
      >
        <van-search
          placeholder="姓名/编号/手机号"
          v-model="contactPage.queryStr"
          @input="onRefresh(contactPage)"
          background="transparent"
        />
        <div class="wrapper">
          <mescroll-vue
            ref="mescroll"
            :down="down"
          >
            <van-pull-refresh
              v-model="contactPage.pullRefreshLoading"
              @refresh="onRefresh(contactPage)"
            >
              <van-list
                v-model="contactPage.loading"
                :finished="contactPage.finished"
                :error.sync="contactPage.error"
                :error-text="contactPage.errorText"
                :finished-text="contactPage.finishedText"
                @load="getContactList(contactPage.pageNum++)"
              >
                <van-row
                  class="common-item bg-white"
                  v-for="(contact, i) in contactPage.list"
                  :key="i"
                  type="flex"
                  align="center"
                >

                  <van-col :span="20">
                    <h4 class="common-item__title">
                      {{ contact.chName }}  {{ contact.phoneNumber }}0000
                    </h4>
                    <div class="common-item__label">
                      <span v-if="contact.numberLabel">{{ contact.numberLabel }}：</span>
                      {{ contact.numberStr }}
                    </div>
                  </van-col>
                  <van-col
                    :span="4"
                    class="text-center"
                    @click.stop="editContact(contact)"
                  >
                    <van-icon
                      size="18"
                      name="edit"
                    />
                  </van-col>
                </van-row>
              </van-list>
            </van-pull-refresh>
          </mescroll-vue>
        </div>
      </van-tab>


      <van-tab
        name="2"
        title="常用地址"
      >
        <div class="wrapper">
          <mescroll-vue
            ref="mescroll"
            :down="down"
          >
            <van-list
              v-model="addressPage.loading"
              :finished="addressPage.finished"
              :error.sync="addressPage.error"
              :error-text="addressPage.errorText"
              :finished-text="addressPage.finishedText"
              @load="getAddressList()"
            >
              <van-row
                class="common-item bg-white"
                v-for="(address, i) in addressPage.list"
                :key="i"
                type="flex"
                align="center"
              >
                <van-col :span="20">
                  <h4 class="common-item__title">
                    {{ address.recipient }} {{ address.phoneNumber }}
                  </h4>
                  <div class="common-item__label">
                    {{ address.addr }}
                  </div>
                  <div class="common-item__label">
                    {{ address.post }}
                  </div>
                </van-col>
                <van-col
                  :span="4"
                  class="text-center"
                  @click.stop="editAddress(address)"
                >
                  <van-icon
                    size="18"
                    name="edit"
                  />
                </van-col>
              </van-row>
            </van-list>
          </mescroll-vue>
        </div>
      </van-tab>


      <van-tab
        name="3"
        title="附属人"
      >
        <div class="wrapper">
          <mescroll-vue
            ref="mescroll"
            :down="down"
          >
            <van-pull-refresh
              v-model="vipEmpFSPage.pullRefreshLoading"
              @refresh="onRefresh(vipEmpFSPage)"
            >
              <van-list
                v-model="vipEmpFSPage.loading"
                :finished="vipEmpFSPage.finished"
                :error.sync="vipEmpFSPage.error"
                :error-text="vipEmpFSPage.errorText"
                :finished-text="vipEmpFSPage.finishedText"
                @load="getVipEmpFSList(vipEmpFSPage.pageNum++)"
              >
                <van-row
                  class="common-item bg-white"
                  v-for="(vipEmpFS, i) in vipEmpFSPage.list"
                  :key="i"
                  type="flex"
                  align="center"
                  @click="editContact(vipEmpFS)"
                >
                  <van-col :span="20">
                    <h4 class="common-item__title">
                      {{ vipEmpFS.chName }} {{ vipEmpFS.phoneNumber }}
                    </h4>
                    <div class="common-item__label">
                      {{ $t('D008','证件号码') }}：{{ vipEmpFS.numberStr }}
                    </div>
                  </van-col>
                  <van-col
                    :span="4"
                    class="text-center"
                    @click.stop="editContact(vipEmpFS)"
                  >
                    <van-icon
                      size="18"
                      name="edit"
                    />
                  </van-col>
                </van-row>
              </van-list>
            </van-pull-refresh>
          </mescroll-vue>
        </div>
      </van-tab>
    </van-tabs>

    <div
      v-if="active != 3"
      class="add-btn linear-main2"
      @click="add"
    >
      <van-icon
        color="#fff"
        name="plus"
        size="34"
      />
    </div>
  </div>
</template>

<script>
import { Search, Tab, Tabs, List, PullRefresh } from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import contactsInteractor from 'Domain/use-cases/contacts-interactor'
import vipEmpFSInteractor from 'Domain/use-cases/vipEmpFS-interactor'
import addressInteractor from 'Domain/use-cases/address-interactor'

export default {
  name: 'CommonInfo',
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Search.name]:Search,
    MescrollVue,
  },
  data() {
    return {
      active: 1,
      contactPage: {
        queryStr: '',
        pageNum: 0,
        count: 10,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载',
        pullRefreshLoading: false,
        list: [],
        searchName: 'getContactList',
      },
      vipEmpFSPage: {
        pageNum: 0,
        count: 10,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载',
        pullRefreshLoading: false,
        list: [],
        searchName: 'getVipEmpFSList',
      },
      addressPage: {
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载',
        pullRefreshLoading: false,
        list: [],
        searchName: 'getAddressList',
      },
      down: { use: false },
    }
  },
  methods: {
    add () {
      if (this.active == 1) {
        this.$router.push({ path: '/userCenter/CommonInfo/EditContact' })
      } else {
        this.$router.push({ path: '/userCenter/CommonInfo/EditAddress' })
      }
    },
    onRefresh(page) {
      page.list = []
      page.pageNum = 1
      page.pullRefreshLoading = false
      page.finished = false
      this[page.searchName]()
    },
    /**
     * 获取常旅客列表
     */
    async getContactList () {
      try {
        if (this.contactPage.pageNum === 0) return

        this.contactPage.loading = true
        let params = {
          queryStr: this.contactPage.queryStr,
          pageNum: this.contactPage.pageNum,
          count: this.contactPage.count
        }
        const { data } = await contactsInteractor.getContactsList(params)

        this.contactPage.loading = false
        if (data.length < this.contactPage.count) {
          this.contactPage.finished = true
        }

        if (params.pageNum > 1) {
          this.contactPage.list.push(...data)
        } else {
          this.contactPage.list = data
        }

      } catch (error) {
        this.contactPage.error = true
      }
    },
    editContact ({ id }) {
      this.$router.push({ path: `/userCenter/CommonInfo/EditContact/${id}` })
    },
    /**
     * 删除常旅客
     */
    deleteContact ({ contactsId }) {
      this.$dialog.confirm({
        message: '确定删除吗？'
      }).then(async () => {
        await contactsInteractor.deleteContacts(contactsId)
        this.$dialog({ message: '删除成功！' })
        this.getContactList()
      })
    },
    /**
     * 获取常用地址列表
     */
    async getAddressList () {
      try {
        this.addressPage.loading = true
        const { data } = await addressInteractor.getAddressList()

        this.addressPage.loading = false
        this.addressPage.finished = true

        this.addressPage.list = data

      } catch (error) {
        this.addressPage.error = true
      }
    },
    editAddress ({ id }) {
      this.$router.push({ path: `/userCenter/CommonInfo/EditAddress/${id}` })
    },
    /**
     * 获取员工附属人列表
     */
    async getVipEmpFSList () {
      try {
        if (this.vipEmpFSPage.pageNum === 0) return

        this.vipEmpFSPage.loading = true
        let params = {
          pageNum: this.vipEmpFSPage.pageNum,
          count: this.vipEmpFSPage.count
        }
        const { data } = await vipEmpFSInteractor.getVipEmpFSList(params)

        this.vipEmpFSPage.loading = false
        if (data.length < this.vipEmpFSPage.count) {
          this.vipEmpFSPage.finished = true
        }
        if (params.pageNum > 1) {
          this.vipEmpFSPage.list.push(...data)
        } else {
          this.vipEmpFSPage.list = data
        }

      } catch (error) {
        this.vipEmpFSPage.error = true
      }
    }
  }
}
</script>

<style lang="less">
.CommonInfo {
  h3, h4 {
    margin: 0;
  }

  .wrapper {
    height: calc(100vh - 150px);
    overflow: hidden;
    padding: 0 8px;
  }

  .van-tabs__nav {
    background-color: transparent;
  }
  .van-search__content {
    background-color: #fff;
  }
  .van-tabs__wrap {
    width: 300px;

    .van-tab--active {
      font-size: @font-size-20;
      z-index: 1;
    }

  }

  .common-item {
    padding: 13px 15px;
    border-radius: @border-radius-sm;
    margin-top: 5px;

    .common-item__label {
      margin-top: 5px;
      font-size: @font-size-12;
      color: @color-text-gray;
    }
  }

  .add-btn {
    position: fixed;
    right: 20px;
    bottom: 60px;
    padding: 10px;
    border-radius: 50%;
    font-size: 0;
    box-shadow: 0px 13px 18px 0px
      rgba(201, 153, 94, 0.23);
  }
}
</style>
